<template>
	<b-modal
		ize="xmd"
		ref="search-free-specimen-modal"
		@hidden="$emit('close')"
		:title="`Buscar Ejemplar Libre`"
		centered
		no-close-on-backdrop
		scrollable
		hide-footer
	>
		<div class="d-flex justify-content-between">
			<b-form-group label="Placa del Ejemplar" class="w-100">
				<b-input-group>
					<b-form-input
						:class="{ 'is-invalid': errorMessage }"
						v-model="specimenPlate"
						placeholder="Ingrese placa"
						@keyup.enter="searchSpecimenByPlate"
					></b-form-input>
					<b-input-group-append>
						<b-button variant="outline-primary" @click="searchSpecimenByPlate">
							<feather-icon icon="SearchIcon" />
						</b-button>
					</b-input-group-append>
				</b-input-group>
				<small class="text-danger" v-if="errorMessage">{{ errorMessage }}</small>
			</b-form-group>
		</div>
		<div v-if="selectedSpecimen" class="d-flex justify-content-center my-2">
			<SpecimenPlate :specimen="selectedSpecimen" show_status />
		</div>
		<div class="w-100 d-flex align-items-center justify-content-end">
			<b-button
				class="d-flex align-items-center justify-content-center"
				variant="outline-primary"
				@click="saveSpecimenLocation"
			>
				Confirmar ejemplar
			</b-button>
		</div>
	</b-modal>
</template>

<script>
import SpecimenPlate from "@/components/specimens/SpecimenPlate.vue"
import SpecimenLocationService from "@/views/brain/specimens/views/location/services/specimen-location.service.js"

export default {
	props: {
		location: {
			type: Object,
			required: true,
		},
	},
	components: { SpecimenPlate },
	data() {
		return {
			specimenPlate: "",
			specimenPlateError: false,
			isActive: false,
			errorMessage: null,
			selectedSpecimen: null,
		}
	},
	async mounted() {
		this.$refs["search-free-specimen-modal"].toggle()
	},
	methods: {
		async searchSpecimenByPlate() {
			this.errorMessage = null
			try {
				if (!this.specimenPlate) return
				if (this.selectedSpecimen && this.selectedSpecimen.plate === this.specimenPlate) {
					this.showToast("warning", "top-right", "Búsqueda", "InfoIcon", "El ejemplar ya está seleccionado")
					return
				}
				const { data } = await SpecimenLocationService.searchFreeSpecimen({
					plate: this.specimenPlate,
				})
				this.selectedSpecimen = data
			} catch (error) {
				this.errorMessage = error.response.data.message || "Error al buscar el ejemplar"
				this.selectedSpecimen = null
			}
		},
		async saveSpecimenLocation() {
			if (!this.selectedSpecimen) return
			try {
				this.isPreloading()
				await SpecimenLocationService.saveSpecimenLocation({
					specimen_id: this.selectedSpecimen.id,
					location_id: this.location.id,
				})
				this.showSuccessToast("Ejemplar asignado correctamente")
				this.$emit("refresh")
				this.$emit("close")
			} catch (error) {
				console.log(error)
			} finally {
				this.isPreloading(false)
			}
		},
	},
}
</script>

<style scoped lang="scss"></style>
